import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");

export class LandingPageService {
  static async updateLadingRequest(listId: string, id: string, fields: any) {
    return api
      .patch(getURL(`/sites/${SPSiteId}/lists/${listId}/items/${id}/fields`), fields)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }
}
